<template>
  <div class="account_container">
    <div class="main-content">
      <!-- <el-tabs v-model="activeName">
        <el-tab-pane label="邀请" name="second">

        </el-tab-pane>
      </el-tabs> -->
      <!-- login  -->
      <div v-show="loggedIn===true" class="customers_acc">
        <div class="grid">
          <p v-show="this.$store.state.orders.orderTimeFrame.length===0">{{ $t('noPlacedOrder') }}</p>
          <div class="order_top">
            <el-select v-model="option" v-bind:placeholder="$t('last3Month')" value="" @change="updateFilter">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="$t(item.label)"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <ul class="responsive-table">
            <li v-for="(item, index) in this.$store.state.orders.orderTimeFrame" :key="index">
              <div class="itemTop" @click="navTo(item.SalesOrder_id)">
                <div>{{ $t('orderNo') }}：#{{item.SONum}}</div>
                <div class="date" v-if="!isMobile">{{item.OrderDate}}</div>
                <div class="status">{{item.PaymentStatus}}</div>
              </div>
              <div class="itemCon">
                <div class="itemconLeft">
                  <div><span>{{$t('delivery')}}：</span>{{item.DispatchDate}}&nbsp;{{item.TimeRange}}</div>
                  <div v-if="isMobile"><span>{{$t('order')}}：</span>{{item.OrderDate}}</div>
                  <div v-if='item.SaleStatus==="Delivered"'><span>{{ $t('fulfillmentStatus') }}：</span>{{$t('inTransit')}}</div>
                  <div v-if='item.SaleStatus!=="Delivered"'><span>{{ $t('fulfillmentStatus') }}：</span>{{item.SaleStatus}}</div>
                </div>
                <div class="itemconRight">
                  <div>{{ $t('total') }}</div>
                  <span>${{item.FinalPrice}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
export default {
  name: "account-order",
  data(){
    return{
      activeName:'second',
      orderTimeFrame:[],
      loaded: false,
      // option: 'last 3 month',
      option: '',
      options: [{
        value: '1',
        label: 'last3Month'
      }, {
        value: '2',
        label: 'last6Month'
      }, {
        value: '3',
        label: 'last12Month'
      },{
        value: '4',
        label: 'all'
      },],
       tabs: [
        {
          name: 'All',
          displayName: '全部',
        },
        {
          name: 'Pending',
          displayName: '等待付款',
        },
        {
          name: 'Processing',
          displayName: '处理中',
        },
        {
          name: 'Shipped',
          displayName: '已运送',
        },
      ],
      activeTabName: null,
      list:[],
      isMobile:isMobile
    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails','cancelOrder','fetchConsolidatedOrders']),
    navTo(id) {
        this.$router.push({name: 'order', params: {order_id: id}});
    },
    updateFilter(value) {
      //console.log("value",value);
      if(value === '1') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
      }
      if(value === '2') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 6);
      }
      if(value === '3') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 12);
      }
      if(value=== '4'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 99);
      }     
    },
  },
  mounted() {
    //const month = 3;
    //this.$store.dispatch('orders/fetchOrderByTimeFrame',month);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {
    '$store.state.orders.orderTimeFrame': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }  
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/order.vue